import { useEffect, useRef } from "react";
import Attribution from "ol/attribution";
import Extent from "ol/extent";
import Fill from "ol/style/fill";
import GeoJSON from "ol/format/geojson";
import Map from "ol/map";
import Overlay from "ol/overlay";
import Select from "ol/interaction/select";
import Stroke from "ol/style/stroke";
import Style from "ol/style/style";
import Tile from "ol/layer/tile";
import VectorLayer from "ol/layer/vector";
import VectorSource from "ol/source/vector";
import View from "ol/view";
import XYZ from "ol/source/xyz";
import condition from "ol/events/condition";
import interaction from "ol/interaction";
import proj from "ol/proj";
import "ol/ol.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";


function displayLogic(mapTarget, regionsData, forecastData) {
    /**
     * Setup the global variable so we only call this once
     */
    let forecastMap;
    let extent;

    let anchor = document.createElement("a");

    let green = [46, 218, 46, 0.3];
    let highlightedGreen = [46, 218, 46, 0.6];
    let yellow = [252, 245, 6, 0.3];
    let highlightedYellow = [252, 245, 6, 0.8];
    let orange = [249, 120, 16, 0.3];
    let highlightedOrange = [249, 120, 16, 0.6];
    let red = [246, 27, 27, 0.3];
    let highlightedRed = [246, 27, 27, 0.6];
    let purple = [152, 0, 75, 0.3];
    let highlightedPurple = [152, 0, 75, 0.6];

    let regionColorMap = {
        "Metropolitan Baltimore": {"normal": green, "highlighted": highlightedGreen},
        "Maryland Piedmont": {"normal": green, "highlighted": highlightedGreen},
        "Northern Baltimore": {"normal": green, "highlighted": highlightedGreen},
        "Northeast Maryland": {"normal": green, "highlighted": highlightedGreen},
        "Suburban DC": {"normal": green, "highlighted": highlightedGreen},
        "Upper Eastern Shore": {"normal": green, "highlighted": highlightedGreen},
        "Southern Maryland": {"normal": green, "highlighted": highlightedGreen},
        "Northern VA/DC": {"normal": green, "highlighted": highlightedGreen}
    };

    window.jQuery(document).ready(function () {
        updateRegionColorMap();

        // anchor element for forecast table
        anchor.setAttribute("href", "#forecastRegionTable");
        document.getElementById("forecasts").appendChild(anchor);
        window.jQuery(anchor).click(function () {
            if (window.location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                || window.location.hostname == this.hostname) {
                let target = window.jQuery(this.hash);
                target = target.length ? target : window.jQuery('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    window.jQuery('html,body').animate({
                        scrollTop: target.offset().top - 200
                    }, 800);
                    return false;
                }
            }
        });

        // a javascript object literal can be used to cache
        // previously created styles. Its very important for
        // performance to cache styles.
        let styleCache = {};

        // the style function returns an array of styles
        // for the given feature and resolution.
        // Return null to hide the feature.
        function styleFunction(feature, resolution) {
            // get the incomeLevel from the feature properties
            let region = feature.getId();
            // check the cache and create a new style for the income
            // level if its not been created before.
            if (!styleCache[region]) {
                styleCache[region] = new Style({
                    stroke: new Stroke({
                        color: regionColorMap[region]["highlighted"],
                        width: 5
                    }),
                    fill: new Fill({
                        color: regionColorMap[region]["normal"]
                    })
                });
            }
            // at this point, the style for the current level is in the cache
            // so return it (as an array!)
            return [styleCache[region]];
        }

        // creating region p
        let source = new VectorSource({
            features: (new GeoJSON({
                defaultDataProjection: 'EPSG:4326'
            })).readFeatures(regionsData, {
                dataProjection: 'EPSG:4326',
                featureProjection: 'EPSG:3857'
            })
        });

        let layer = new VectorLayer({
            source: source,
            style: styleFunction
        });


        // creating maps
        let attribution = new Attribution({
            html: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
            'rest/services/World_Street_Map/MapServer">ArcGIS</a>'
        });

        forecastMap = new Map({
            target: mapTarget,
            layers: [
                new Tile({
                    source: new XYZ({
                        attributions: [attribution],
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                        'World_Street_Map/MapServer/tile/{z}/{y}/{x}'
                    })
                }),
                layer
            ],
            view: new View({
                center: proj.fromLonLat([-76.904567, 38.751838]),
                zoom: 8
            }),
            interactions: interaction.defaults({
                doubleClickZoom: false,
                mouseWheelZoom: false,
                pointer: false,
                select: true,
                dragPan: false,
                pinchRotate: false,
                pinchZoom: false,
                shiftDragZoom: false,
                keyboard: false
            }),
            controls: []
        });

        // select interaction working on "pointermove"
        let selectPointerMove = new Select({
            condition: condition.pointerMove
        });
        forecastMap.addInteraction(selectPointerMove);

        let popup = document.createElement("div");
        popup.id = "popup";
        document.getElementById("forecasts").appendChild(popup);
        // Popup showing the position the user clicked
        let popupOverlay = new Overlay({
            element: popup,
            positioning: 'bottom-center',
            offset: [0, -10]
        });
        forecastMap.addOverlay(popupOverlay);
        let element = popupOverlay.getElement();

        selectPointerMove.on('select', function (e) {
            if (e.deselected.length) {
                // window.jQuery(element).popover('hide');
                e.deselected[0].setStyle(
                    new Style({
                        stroke: new Stroke({
                            color: regionColorMap[e.deselected[0].getId()]["highlighted"],
                            width: 5
                        }),
                        fill: new Fill({
                            color: regionColorMap[e.deselected[0].getId()]["normal"]
                        })
                    })
                );
                window.jQuery(element).popover('hide');
            }

            if (e.selected.length) {
                e.selected[0].setStyle(
                    new Style({
                        stroke: new Stroke({
                            color: regionColorMap[e.selected[0].getId()]["highlighted"],
                            width: 5
                        }),
                        fill: new Fill({
                            color: regionColorMap[e.selected[0].getId()]["highlighted"]
                        })
                    })
                );

                let coordinate;
                if (e.selected[0].getGeometry().getType() === 'Polygon') {
                    coordinate = e.selected[0].getGeometry().getInteriorPoint().getCoordinates();
                } else if (e.selected[0].getGeometry().getType() === 'MultiPolygon') {
                    // Get the sum of the center of all the points in the multipolygon
                    coordinate = e.selected[0].getGeometry().getInteriorPoints().getCoordinates().reduce((previousValue, currentValue) => {
                        previousValue[0] += currentValue[0];
                        previousValue[1] += currentValue[1];
                        return previousValue;
                    }, [0, 0]);

                    // Divide by the number of polygons in the multipolygon to get the 'true' center
                    coordinate[0] /= e.selected[0].getGeometry().getInteriorPoints().getCoordinates().length;
                    coordinate[1] /= e.selected[0].getGeometry().getInteriorPoints().getCoordinates().length;
                }
                let content = e.selected[0].getId() + "<br/>" + "Today: " + getCategoriesForRegion(e.selected[0].getId()).today +
                    "<br/>" + "Tomorrow: " + getCategoriesForRegion(e.selected[0].getId()).tomorrow;

                window.jQuery(element).popover('dispose');
                popupOverlay.setPosition(coordinate);
                window.jQuery(element).popover({
                    'animation': false,
                    'html': true,
                    'content': content
                });
                window.jQuery(element).popover('show');
            }
        });

        // select interaction working on "click"
        let selectClick = new Select({
            condition: condition.click
        });

        forecastMap.addInteraction(selectClick);

        selectClick.on('select', function (e) {
            if (e.selected.length) {
                e.selected[0].setStyle(
                    new Style({
                        stroke: new Stroke({
                            color: regionColorMap[e.selected[0].getId()]["highlighted"],
                            width: 5
                        }),
                        fill: new Fill({
                            color: regionColorMap[e.selected[0].getId()]["highlighted"]
                        })
                    })
                );
                highlightTableForRegion(e.selected[0].getId());
            }

            if (e.deselected.length) {
                e.deselected[0].setStyle(
                    new Style({
                        stroke: new Stroke({
                            color: regionColorMap[e.deselected[0].getId()]["highlighted"],
                            width: 5
                        }),
                        fill: new Fill({
                            color: regionColorMap[e.deselected[0].getId()]["normal"]
                        })
                    })
                );
            }
        });
        forecastMap.on("click", function (e) {
            window.jQuery(element).popover('hide');
        });

        // build map extent
        extent = Extent.createEmpty();
        Extent.extend(extent, layer.getSource().getExtent());

        refreshMapView();

        // HANDLE RESIZING MAP WITH WINDOW
        window.jQuery(window).resize(function (e) {
            if (forecastMap) {
                refreshMapView();
            }
        });
    });

    function refreshMapView() {
        forecastMap.getView().fit(extent, {
            minResolution: 420,
            constrainResolution: false,
            padding: [10, 5, 10, 5]
        });
    }

    function updateRegionColorMap() {
        for (let region in regionColorMap) {
            switch (region) {
                case "Northern VA/DC":
                    if (Object.keys(forecastData["northern_virginia_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["northern_virginia_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
                case "Metropolitan Baltimore":
                    if (Object.keys(forecastData["metro_baltimore_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["metro_baltimore_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
                case "Maryland Piedmont":
                    if (Object.keys(forecastData["maryland_piedmont_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["maryland_piedmont_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
                case "Northern Baltimore":
                    if (Object.keys(forecastData["northern_baltimore_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["northern_baltimore_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
                case "Northeast Maryland":
                    if (Object.keys(forecastData["northeast_maryland_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["northeast_maryland_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
                case "Suburban DC":
                    if (Object.keys(forecastData["suburban_dc_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["suburban_dc_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
                case "Upper Eastern Shore":
                    if (Object.keys(forecastData["upper_eastern_shore_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["upper_eastern_shore_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
                case "Southern Maryland":
                    if (Object.keys(forecastData["southern_maryland_max"]["today_forecast"]).length === 0) {
                        regionColorMap[region] = getColorForCategory("default");
                    } else {
                        regionColorMap[region] = getColorForCategory(forecastData["southern_maryland_max"]["today_forecast"]["aqiCategory"]);
                    }
                    break;
            }
        }
    }

    function getCategoriesForRegion(region) {
        let categories = {};
        let today = "N/A";
        let tomorrow = "N/A";
        switch (region) {
            case "Northern VA/DC":
                if (Object.keys(forecastData["northern_virginia_max"]["today_forecast"]).length > 0) {
                    today = forecastData["northern_virginia_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["northern_virginia_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["northern_virginia_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;

            case "Metropolitan Baltimore":
                if (Object.keys(forecastData["metro_baltimore_max"]["today_forecast"]).length > 0) {
                    today = forecastData["metro_baltimore_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["metro_baltimore_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["metro_baltimore_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;

            case "Maryland Piedmont":
                if (Object.keys(forecastData["maryland_piedmont_max"]["today_forecast"]).length > 0) {
                    today = forecastData["maryland_piedmont_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["maryland_piedmont_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["maryland_piedmont_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;

            case "Northern Baltimore":
                if (Object.keys(forecastData["northern_baltimore_max"]["today_forecast"]).length > 0) {
                    today = forecastData["northern_baltimore_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["northern_baltimore_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["northern_baltimore_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;

            case "Northeast Maryland":
                if (Object.keys(forecastData["northeast_maryland_max"]["today_forecast"]).length > 0) {
                    today = forecastData["northeast_maryland_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["northeast_maryland_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["northeast_maryland_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;

            case "Suburban DC":
                if (Object.keys(forecastData["suburban_dc_max"]["today_forecast"]).length > 0) {
                    today = forecastData["suburban_dc_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["suburban_dc_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["suburban_dc_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;

            case "Upper Eastern Shore":
                if (Object.keys(forecastData["upper_eastern_shore_max"]["today_forecast"]).length > 0) {
                    today = forecastData["upper_eastern_shore_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["upper_eastern_shore_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["upper_eastern_shore_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;

            case "Southern Maryland":
                if (Object.keys(forecastData["southern_maryland_max"]["today_forecast"]).length > 0) {
                    today = forecastData["southern_maryland_max"]["today_forecast"]["aqiCategory"];
                }

                if (Object.keys(forecastData["southern_maryland_max"]["tomorrow_forecast"]).length > 0) {
                    tomorrow = forecastData["southern_maryland_max"]["tomorrow_forecast"]["aqiCategory"];
                }
                categories = {"today": today, "tomorrow": tomorrow};
                break;
        }
        return categories;
    }

    function getColorForCategory(category) {
        let color = {"normal": [255, 255, 255, 0.5], "highlighted": [255, 255, 255, 1]};
        if (category === "Good") {
            color = {"normal": green, "highlighted": highlightedGreen};
        }
        if (category === "Moderate") {
            color = {"normal": yellow, "highlighted": highlightedYellow};
        }
        if (category === "Unhealthy for Sensitive Groups") {
            color = {"normal": orange, "highlighted": highlightedOrange};
        }
        if (category === "Unhealthy") {
            color = {"normal": red, "highlighted": highlightedRed};
        }
        if (category === "Very Unhealthy") {
            color = {"normal": purple, "highlighted": highlightedPurple};
        }
        return color;
    }

    function highlightTableForRegion(region) {
        window.jQuery(anchor).click();

        switch (region) {
            case "Northern Virginia and DC":
                window.jQuery("#northernVirginiaForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
            case "Metropolitan Baltimore":
                window.jQuery("#metroBaltimoreForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
            case "Maryland Piedmont":
                window.jQuery("#marylandPiedmontForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
            case "Northern Baltimore":
                window.jQuery("#northernBaltimoreForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
            case "Northeast Maryland":
                window.jQuery("#northeastMarylandForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
            case "Suburban DC":
                window.jQuery("#suburbanDCForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
            case "Upper Eastern Shore":
                window.jQuery("#upperEasternShoreForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
            case "Southern Maryland":
                window.jQuery("#southernMarylandForecast").delay(300).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400).fadeOut(400).fadeIn(400);
                break;
        }
    }

    return function destroy() {
        if (forecastMap !== undefined) {
            forecastMap.setTarget(null);
        }
    }
}

function ForecastAirQualityDisplay({ aqiCategoryIcons, forecastData, mapRegions, isActive, today }) {
    const mapElement = useRef(null);

    useEffect(() => {
        if (isActive === true) {
            let destroyCallback = displayLogic(mapElement.current, mapRegions.regions, forecastData);
            return () => {
                destroyCallback();
            };
        }
    }, [isActive]);

    const createForecastIconByReportingAreaRecord = (reportingAreaRecord) => {
        let aqiCategory = "Not Available";
        if (reportingAreaRecord && Object.keys(reportingAreaRecord).length > 0) {
            aqiCategory = reportingAreaRecord.aqiCategory;
        }
        let icon;
        if (aqiCategory === "Good") {
            icon = aqiCategoryIcons[0];
        } else if (aqiCategory === "Moderate") {
            icon = aqiCategoryIcons[1];
        } else if (aqiCategory === "Unhealthy") {
            icon = aqiCategoryIcons[2];
        } else if (aqiCategory === "Unhealthy for Sensitive Groups") {
            icon = aqiCategoryIcons[3];
        } else if (aqiCategory === "Very Unhealthy") {
            icon = aqiCategoryIcons[4];
        } else if (aqiCategory === "Not Available") {
            icon = aqiCategoryIcons[6];
        } else {
            icon = aqiCategoryIcons[4];  // Very Unhealthy for everything else
        }
        return (
            <img className="img-responsive forecast-icon"
                 alt={ icon.alternativeText }
                 src={ icon.url } />
        );
    };

    return (
        <div className={"tab-pane " + (isActive === true ? "active" : "")} id="forecasts">

            <div className="map" ref={mapElement} id="forecastMap"></div>

            <div className="section-headline center-align full-width footer-blue white-text" style={{ padding: "10px 0px" }}>
                Forecasts
            </div>
            <div className="region-forecast-container ">
                <div className="col-sm-12 no-padding blue-gradient region-forecast-display">
                    <div className="vertical-align region-forecast-display">
                        <div className="col-sm-12 center-align region-forecast-table-container">

                            <table className="white-text" style={{ width: "100%" }} id="forecastRegionTable">
                                <tbody>
                                <tr>
                                    <th></th>
                                    <th>TODAY { today.format('MM/DD/YYYY') }</th>
                                    <th>TOMORROW { today.clone().add(1, 'days').format('MM/DD/YYYY') }</th>
                                    <th>{today.clone().add(2, 'days').format('dddd').toUpperCase() + " " + today.clone().add(2, 'days').format('MM/DD/YYYY')}</th>
                                    <th>{today.clone().add(3, 'days').format('dddd').toUpperCase() + " " + today.clone().add(3, 'days').format('MM/DD/YYYY')}</th>
                                </tr>

                                <tr id="northernVirginiaForecast">
                                    <th>NORTHERN VA/DC</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_virginia_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>

                                <tr id="metroBaltimoreForecast">
                                    <th>METRO BALTIMORE</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['metro_baltimore_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>

                                <tr id="marylandPiedmontForecast">
                                    <th>MARYLAND PIEDMONT</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['maryland_piedmont_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>

                                <tr id="northernBaltimoreForecast">
                                    <th>NORTHERN BALTIMORE</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['northern_baltimore_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>

                                <tr id="northeastMarylandForecast">
                                    <th>NORTHEAST MARYLAND</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['northeast_maryland_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>

                                <tr id="suburbanDCForecast">
                                    <th>SUBURBAN DC</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['suburban_dc_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>

                                <tr id="upperEasternShoreForecast">
                                    <th>UPPER EASTERN SHORE</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['upper_eastern_shore_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>

                                <tr id="southernMarylandForecast">
                                    <th>SOUTHERN MARYLAND</th>
                                    <td className="forecast-cell-top-left">
                                        { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['today_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['tomorrow_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-center">
                                        { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['day_three_forecast'] ) }
                                    </td>
                                    <td className="forecast-cell-top-right">
                                        { createForecastIconByReportingAreaRecord( forecastData['southern_maryland_max']['day_four_forecast'] ) }
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <span>
                        <img alt="legend" className="full-width" src={ aqiCategoryIcons[5].url } />
                    </span>
                </div>
            </div>

        </div>
    );
}

export default ForecastAirQualityDisplay;
